import React from "react";

const MobileTopBar = ({
    hides, currentHideIndex, setCurrentHideIndex,
    isOrderFinished, isConfigOpen,
    isCapturing, isConfirmDisabled, confirmBtnText,
    handleConfirmPattern,
    collisionType, hasFreeMovePurchase, isAllPreselectedUsed,
    currentHide,
    isFormValid,
    t,
}) => (
    <>
        {/* Mobile top header — grid layout with hide select + confirm */}
        <div className="d-flex d-md-none w-100 px-3 pt-3 pb-2 gap-2"
            style={{ zIndex: 1500, position: 'absolute', top: 0, left: 0, height: '75px', display: 'grid !important', gridTemplateColumns: '1fr 1fr', alignItems: 'center', backgroundColor: '#FCFBF7' }}>
            <div id="tour-step-mobile-hide" style={{ width: '100%', overflow: 'hidden' }}>
                <select className="luxury-dropdown fw-bold"
                    style={{ height: '44px', width: '100%', borderRadius: '25px', paddingLeft: '15px', border: '1px solid rgba(197, 160, 117, 0.4)', fontSize: '12px', backgroundColor: '#FFFFFF', backgroundPosition: 'right 10px center' }}
                    value={currentHideIndex}
                    onChange={(e) => { setCurrentHideIndex(Number(e.target.value)); }}
                    disabled={isOrderFinished || isConfigOpen}>
                    {hides.map((hide, index) => (
                        <option key={hide._id} value={index}>{hide.name}</option>
                    ))}
                </select>
            </div>
            <div id="tour-step-mobile-confirm" style={{ width: '100%', overflow: 'hidden' }}>
                <button
                    onClick={handleConfirmPattern}
                    disabled={isConfirmDisabled}
                    className="btn rounded-pill fw-bold shadow-sm d-flex align-items-center justify-content-center gap-1 w-100"
                    style={{ backgroundColor: (collisionType || hasFreeMovePurchase || isAllPreselectedUsed || currentHide.isHidden) ? '#dc3545' : (isConfirmDisabled ? '#EAE4DA' : '#C5A075'), color: '#fff', height: '44px', width: '100%', border: 'none', fontSize: '10px', padding: '0 8px', whiteSpace: 'nowrap', opacity: isConfirmDisabled ? 0.9 : 1, display: 'flex' }}
                >
                    {isCapturing ? <span className="spinner-border spinner-border-sm"></span> : (
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{confirmBtnText}</span>
                    )}
                </button>
            </div>
        </div>

        {/* Mobile static overlay select (pointer-events none wrapper) */}
        <div className="d-flex d-md-none w-100 justify-content-between align-items-center px-3 pt-3 pb-2 position-absolute top-0 start-0 gap-2" style={{ zIndex: 1200, pointerEvents: 'none' }}>
            <div className="flex-grow-1" style={{ pointerEvents: 'auto' }}>
                <select className="form-select rounded-pill fw-bold px-3 shadow-lg text-dark w-100"
                    style={{ border: 'none', height: '48px', backgroundColor: '#fff', fontSize: '14px', appearance: 'none', backgroundImage: 'url("data:image/svg+xml;utf8,<svg fill=%27%23C5A075%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>")', backgroundRepeat: 'no-repeat', backgroundPositionX: 'calc(100% - 15px)', backgroundPositionY: 'center' }}
                    value={currentHideIndex}
                    onChange={(e) => { setCurrentHideIndex(Number(e.target.value)); }}
                    disabled={isOrderFinished || isConfigOpen}>
                    {hides.map((hide, index) => (
                        <option key={hide._id} value={index}>
                            {hide.name} {hide.isHidden ? `(${t('sold_out', 'SOLD OUT')})` : ''}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    </>
);

export default MobileTopBar;
